import axios from "axios";
import React from "react";
import { useRef } from "react";
import { FaSearch } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import UserContext from "../UserContext";
import { url } from "../utils/url";
import NavbarSearchResult from "./Search/NavbarSearchResult";
import Logoname from "../img/logo/logo-name.png";

export default function Navbar() {
  const { user, searchHommies, mode } = React.useContext(UserContext);
  const [key, setKey] = React.useState("");
  const [searchResults, setSearchResults] = React.useState([]);
  const [isSearchCardShown, setisSearchCardShown] = React.useState(false);
  const [loading, setloading] = React.useState(false);

  const location = useLocation();

  const submitForm = (e) => {
    e.preventDefault();
    if (!key) {
      window.displayToastError("Enter anything to search");
      return;
    }
    setisSearchCardShown(false);
    searchHommies(key);
  };

  const filterSearch = async () => {
    if (!key) {
      setSearchResults([]);
      return;
    }
    setloading(true);
    let tempResults = [];
    await axios
      .get(`${url}/api/auth/search?key=${key}`)
      .then((res) => {
        tempResults = res.data.data;
      })
      .catch((err) => {});
    if (tempResults) {
      setSearchResults(tempResults);
    }
    setloading(false);
  };

  const handleKeyChange = async (e) => {
    setKey(e.target.value);
  };

  let inputRef = useRef();
  let cardRef = useRef();

  React.useEffect(() => {
    filterSearch();
    let l = document.addEventListener("click", (e) => {
      if (isSearchCardShown) {
        setisSearchCardShown(
          e.target === inputRef.current || e.target === cardRef.current
            ? isSearchCardShown
            : false
        );
      }
    });
    return () => {
      document.removeEventListener("click", l);
    };
    // eslint-disable-next-line
  }, [key]);

  // setting the theme
  const [dark, setDark] = React.useState(false);
  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <div
      className={
        dark === true
          ? "flex justify-center w-full border sticky divbg-in-darkmode top-0 z-50 py-2 darkmode"
          : "flex justify-center w-full border sticky top-0 z-50 bg-white py-2"
      }
    >
      <div className="w-full px-2 md:w-3/4 flex justify-between items-center">
        <Link
          to="/"
          className="px-1 flex items-center"
          onClick={() => {
            location.pathname === "/" &&
              window.scrollTo({
                left: 0,
                top: 0,
              });
          }}
        >
          {" "}
          <img src={Logoname} alt="Logo" width="50" />
          {/* <div>Twika 🔥🔥 </div> */}
        </Link>
        <div
          className={
            dark === true
              ? "navbar__search darkmode divbg-in-darkmode"
              : "navbar__search"
          }
        >
          <form
            className={
              dark === true
                ? "bg-gray-100 navbar__searchForm"
                : "bg-gray-100 navbar__searchForm"
            }
            onSubmit={submitForm}
          >
            <input
              type="text"
              placeholder="Search hommies"
              className={
                dark === true
                  ? "bg-gray-100 navbar__searchInput searchClickAllowed darkmode"
                  : "bg-gray-100 navbar__searchInput searchClickAllowed "
              }
              value={key}
              onChange={handleKeyChange}
              onFocus={() => setisSearchCardShown(true)}
              ref={inputRef}
            />
            <FaSearch
              className="navbar__searchSubmit"
              onClick={submitForm}
            ></FaSearch>
            <div
              ref={cardRef}
              className={
                isSearchCardShown && key
                  ? dark === true
                    ? "navbar__searchCard shown shadow-xl darkmode"
                    : "navbar__searchCard shown shadow-xl"
                  : dark === true
                  ? "navbar__searchCard shadow-xl darkmode"
                  : "navbar__searchCard shadow-xl"
              }
            >
              {!key ? (
                <div className=" bg-gray-100 empty-message">
                  Start typing to search your hommies
                </div>
              ) : loading ? (
                <div
                  className={
                    dark === true
                      ? "text-muted font-bold empty-message darkmode"
                      : "text-muted font-bold empty-message"
                  }
                >
                  Loading...
                </div>
              ) : searchResults.length === 0 ? (
                <div
                  className={
                    dark === true
                      ? "text-muted font-bold empty-message darkmode"
                      : "text-muted font-bold empty-message"
                  }
                >
                  No results found
                </div>
              ) : (
                <div
                  className={
                    dark === true
                      ? "searchHommies-list darkmode"
                      : "searchHommies-list"
                  }
                >
                  <h1 className="text-muted py-2 font-bold text-sm md:px-4 sm:px-1">
                    Accounts
                  </h1>
                  {searchResults.map((result) => (
                    <NavbarSearchResult
                      user={result}
                      key={result._id}
                      paddingX={true}
                    ></NavbarSearchResult>
                  ))}
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="navbar__right">
          <div className="navbar__rightIcons">
            {/* <FaBell className="navbar__rightIcon"></FaBell>
          <FaUserCircle></FaUserCircle> */}
          </div>
          <div className="navbar__rightJoinButton flex justify-between items-center">
            <Link
              to={user.token ? "/games" : "/login"}
              className="navbar_links"
            >
              Games
            </Link>
            <Link to="/explore" className="navbar_links">
              Explore
            </Link>
            <Link
              to={user.token ? "/logout" : "/login"}
              className="navbar_links"
            >
              {user.token ? "Logout" : "Login"}
            </Link>

            {/* darkmode */}
            {/* {dark ? (
              <div className="mr-5 cursor-pointer" onClick={() => setMode()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-6.671-5.575A8 8 0 1 0 16.425 5.328a8.997 8.997 0 0 1-2.304 8.793 8.997 8.997 0 0 1-8.792 2.304z"
                    fill="rgba(255,255,255,1)"
                  />
                </svg>
              </div>
            ) : (
              <div className="mr-5 cursor-pointer" onClick={() => setMode()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path
                    d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-6.671-5.575A8 8 0 1 0 16.425 5.328a8.997 8.997 0 0 1-2.304 8.793 8.997 8.997 0 0 1-8.792 2.304z"
                    fill="rgba(0,0,0,1)"
                  />
                </svg>
              </div>
            )} */}

            <Link
              to={user.token ? "/messages" : "/register"}
              className="join_btn"
            >
              {" "}
              <button>{user.token ? "Messages" : "Join for free"}</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
